module.exports = __webpack_public_path__ + "images/旅悦好物全景_05.jpg?v=d681dbd6";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_05.jpg
 ** module id = 135
 ** module chunks = 1 2
 **/